<template>
  <v-container fluid>
    <page-header @menuClick="changeReport" :menuItems="menuItems"> 
      {{reportName}} Report </page-header>

    <component :is="selectedComponent"/>

  </v-container>
</template>

<script>
const PageHeader = () => import("@/components/common/PageHeader.vue");
const TeachersPayrolls = () => import("@/components/report/TeachersPayrolls.vue");
const Attendance = () => import("@/components/report/Attendance.vue");
import { mapActions, mapGetters } from "vuex";


export default {
  data() {
    return {
      selectedReport: this.$route.params.reportName ? this.$route.params.reportName:'payroll-report',
    };
  },
  computed: {
    ...mapGetters(["currentUser", "isAppLoading"]),
    reportName(){
      return this.menuItems.find(m => m.id == this.selectedReport).text;
    },
    selectedComponent(){
      return this.menuItems.find(m => m.id == this.selectedReport).value;
    },
    menuItems(){
      return [
        {
          id: "attendance-report",
          text: "Attendance Report",
          icon: "mdi-credit-card",
          value: 'Attendance',
          disabled: this.selectedReport == 'attendance-report'
        },
        {
          id: "payroll-report",
          text: "Payroll Report",
          icon: "mdi-credit-card",
          value: 'TeachersPayrolls',
          disabled: this.selectedReport == 'payroll-report'
        },
      ]
    } 
  },
  mounted() {
    
  },
  methods: {
    ...mapActions(["addErrorMessage", "clearMessage"]),
    changeReport(event, menuItem){
      this.selectedReport = menuItem.id;
      this.$router.push({name: 'Reports', params: {reportName: this.selectedReport}})
    }
  },
  components: {
    PageHeader,
    TeachersPayrolls,
    Attendance
  },
};
</script>